export enum ListBuildingListAction {
  LIST_UPDATE_DETAILS = 'update_details',
}

export enum ListBuildingSectionAction {
  SECTION_CREATE = 'create',
  SECTION_UPDATE = 'update',
  SECTION_MOVE = 'move',
  SECTION_DELETE = 'delete',
}

export enum ListBuildingItemAction {
  ITEM_CREATE = 'create',
  ITEM_UPDATE_PARAGRAPH = 'update_paragraph',
  ITEM_MOVE = 'move',
  ITEM_DELETE = 'delete',
  ITEM_CREATE_IMPORTANCE = 'create_importance',
  ITEM_UPDATE_IMPORTANCE = 'update_importance',
  ITEM_DELETE_IMPORTANCE = 'delete_importance',
  ITEM_CREATE_LIBRARY_NOTE = 'create_library_note',
  ITEM_UPDATE_LIBRARY_NOTE = 'update_library_note',
  ITEM_DELETE_LIBRARY_NOTE = 'delete_library_note',
  ITEM_CREATE_STUDENT_NOTE = 'create_student_note',
  ITEM_UPDATE_STUDENT_NOTE = 'update_student_note',
  ITEM_DELETE_STUDENT_NOTE = 'delete_student_note',
  ITEM_REQUEST_DIGITISATION = 'request_digitisation',
}

export type ListBuildingAction =
  | ListBuildingListAction
  | ListBuildingSectionAction
  | ListBuildingItemAction;
